import { Service } from "@api/common";

export interface VoiceAccessToken {
  token: string;
  identity: string;
  endpointId?: string;
  ttl: number;
  expiresAt: string;
  outgoingApplicationSid: string;
  pushCredentialSid?: string;
}

export class VoiceService extends Service<any> {
  constructor() {
    super("/voice");
  }

  async createAccessToken(params: {
    org: string;
    device?: string;
    incomingAllow?: boolean;
  }): Promise<VoiceAccessToken> {
    return this.post(`${this.basePath}/access-token`, params);
  }
}

export const voiceService = new VoiceService();
